import {
  useState,
  useEffect,
} from 'react';

import {
  Icon,
} from 'web-components';

import Circle from './Circle';
import * as S from './styled';

type Props = {
  src: any,
  width?: number,
  height?: number,
  placeholder?: any,
  uploadProgress?: number,
  onChange?: { (file: any): void },
};

const UploadPhoto = ({
  src,
  width = 130,
  height = 130,
  placeholder,
  uploadProgress = 0,
  onChange,
}: Props) => {
  const [photoPreview, setPhotoPreview] = useState(null);

  useEffect(() => {
    if (src && !photoPreview) {
      setPhotoPreview(src);
    }
  }, [src]);

  return (
    <S.ImageWrapper
      width={`${width}px`}
      height={`${height}px`}
      isEmpty={!photoPreview}
    >
      {(photoPreview || placeholder) && (
        <S.Image
          style={{
            backgroundImage: `url(${photoPreview || placeholder})`,
          }}
          alt="Fail to load preview"
        />
      )}

      <Circle
        radius={width ? width / 2 : 0}
        percent={uploadProgress}
      />

      <div>
        <input
          onChange={(e) => {
            const file = e.target?.files?.[0];
            if (file) {
              setPhotoPreview(
                URL.createObjectURL(
                  file,
                ),
              );
              onChange?.(
                file,
              );
            }
          }}
          type="file"
          accept="image/*"
        />
        <S.UploadText>
          <span>
            <Icon type="fas fa-plus" />
          </span>
          <span>
            {photoPreview ? 'replace' : 'upload'}
          </span>
          <span>
            photo
          </span>
        </S.UploadText>
      </div>
    </S.ImageWrapper>
  );
};

export default UploadPhoto;
